import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: "d6d5bb75-94a2-4882-b85a-964f81d837b7",
    authority: "https://proscancustomers.ciamlogin.com/77db8e48-a9b7-46dd-9045-80d00c42cb28",
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
  },
};

// Add scopes for access token
export const loginRequest: PopupRequest = {
  scopes: [
    "api://d6d5bb75-94a2-4882-b85a-964f81d837b7/dentifier_api"
  ],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};

export const AppRoles = {
    ADMIN: "Dentifier.Admin",
    CUSTOMER: "Dentifier.Customer",
} as const;

export interface UserRoles {
    roles: string[];
    displayGroups: string[];
    email?: string;
    name?: string;
}
